import { createMeta } from "../../../components/TapHeader";

const title = "Candidates";
export const MyJobsMeta = createMeta(title);
